//魔方云
export const systemMovingAssistant = [
  {
    path: '/service/systemMovingAssistant/SystemMovingAssistant',
    name: 'SystemMovingAssistant',
    component: () => import('@/views/service/serviceProvider/systemMovingAssistant/SystemMovingAssistant'),
    meta: {
      title: '系统搬家助手',
      keepAlive: false
    }
  }
]